export default __webpack_public_path__ + "images/choppy_q50.webp";